import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgxSpinnerModule } from 'ngx-spinner';
import { SharedModule } from '../shared/shared.module';
import { OemService } from './oem.service';
import { SasClinicChangePasswordSentComponent } from './sas-clinic-change-password-sent/sas-clinic-change-password-sent.component';
import { SasClinicForgotPasswordComponent } from './sas-clinic-forgot-password/sas-clinic-forgot-password.component';
import { SasClinicInputComponent } from './sas-clinic-input/sas-clinic-input.component';
import { SasClinicLoginComponent } from './sas-clinic-login/sas-clinic-login.component';
import { SasClinicOemHeaderComponent } from './sas-clinic-oem-header/sas-clinic-oem-header.component';
import { SasClinicOemLoginMessageComponent } from './sas-clinic-oem-login-message/sas-clinic-oem-login-message.component';
import { SasClinicOemRegisterMessageComponent } from './sas-clinic-oem-register-message/sas-clinic-oem-register-message.component';
import { SasClinicPasswordInputComponent } from './sas-clinic-password-input/sas-clinic-password-input.component';
import { SasClinicRegisterResendComponent } from './sas-clinic-register-resend/sas-clinic-register-resend.component';
import { SasClinicRegisterSendComponent } from './sas-clinic-register-send/sas-clinic-register-send.component';
import { SasClinicRegisterComponent } from './sas-clinic-register/sas-clinic-register.component';
import { SasClinicResetPasswordComponent } from './sas-clinic-reset-password/sas-clinic-reset-password.component';
import { SasClinicUnblockComponent } from './sas-clinic-unblock/sas-clinic-unblock.component';
import { SasClinicComponent } from './sas-clinic/sas-clinic.component';

@NgModule({
  declarations: [
    SasClinicComponent,
    SasClinicLoginComponent,
    SasClinicRegisterComponent,
    SasClinicUnblockComponent,
    SasClinicRegisterResendComponent,
    SasClinicRegisterSendComponent,
    SasClinicForgotPasswordComponent,
    SasClinicResetPasswordComponent,
    SasClinicChangePasswordSentComponent,
    SasClinicInputComponent,
    SasClinicPasswordInputComponent,
    SasClinicOemHeaderComponent,
    SasClinicOemRegisterMessageComponent,
    SasClinicOemLoginMessageComponent,
  ],
  imports: [
    CommonModule,
    NgxSpinnerModule,
    FormsModule,
    RouterModule,
    SharedModule,
  ],
  exports: [
    SasClinicResetPasswordComponent,
    SasClinicComponent,
    SasClinicRegisterResendComponent,
    SasClinicRegisterSendComponent,
    SasClinicUnblockComponent,
    SasClinicChangePasswordSentComponent,
  ],
  providers: [OemService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SasClinicModule {}
